import get from "lodash/get";

import {
  USER_INFO_LOADING,
  USER_INFO_SUCCESS,
  USER_INFO_FAILED,
  USER_INFO_CLEAR,
  FETCH_FEATURE_FLAGS_LOADING,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE
} from "../actionTypeConstants/UserInfo";
import { isHyExOnPremDomain } from "../../utility/utilityFunctions";
const initialState = {
  userInfo: {
    loading: false,
    data: null,
    error: null
  },
  featureFlags: {
    loading: isHyExOnPremDomain() ? false : true,
    data: [],
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_INFO_LOADING:
      return { ...state, userInfo: { ...state.userInfo, loading: true } };

    case USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          loading: false,
          data: action.result.data
        }
      };

    case USER_INFO_FAILED:
      return {
        ...state,
        userInfo: { ...state.userInfo, loading: false, error: action.error }
      };

    case USER_INFO_CLEAR:
      return { ...state, userInfo: initialState.userInfo };

    case FETCH_FEATURE_FLAGS_LOADING: {
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          loading: true
        }
      };
    }

    case FETCH_FEATURE_FLAGS_SUCCESS: {
      const isOnPremDomain = get(action, ["payload", "isOnPremDomain"], false);
      let flagData = get(action, ["result", "data", "result"], {});
      if (isOnPremDomain) {
        const dataKeys = get(action, ["result", "data", "data"], []);

        dataKeys.forEach(item => {
          flagData[item] = {
            variant: {
              key: "on"
            }
          };
        });
      }

      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          loading: false,
          data: flagData
        }
      };
    }

    case FETCH_FEATURE_FLAGS_FAILURE: {
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          loading: false,
          error: action.error
        }
      };
    }

    default:
      return state;
  }
}
